import React, { useState } from "react";
import "tailwindcss/tailwind.css";
import UPARROW from '../assets/images/uparrow.png';
import DOWNARROW from '../assets/images/Component 1.png';
import LEFTARROW from '../assets/images/leftarrow.png';
import RIGHTARROW from '../assets/images/rightarrow.png';
import OVERVIEW1 from '../assets/images/golf 2.png';
import OVERVIEW2 from '../assets/images/2.png';
import OVERVIEW3 from '../assets/images/3.png';
import OVERVIEW4 from '../assets/images/4.png';
import OVERVIEW5 from '../assets/images/5.png';
import OVERVIEW6 from '../assets/images/6.png';
import OVERVIEW7 from '../assets/images/7.png';

const slides = [
    { id: 1, img: OVERVIEW1,  },
    // { id: 2, img: OVERVIEW2, },
    { id: 3, img: OVERVIEW3, },
    { id: 4, img: OVERVIEW4, },
    { id: 5, img: OVERVIEW5, },
    { id: 6, img: OVERVIEW6, },
    { id: 7, img: OVERVIEW7,},
];

const VerticalCarousel = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const slideCount = slides.length;

    const handleNext = () => {
        if (activeSlide < slideCount - 1) {
            setActiveSlide((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (activeSlide > 0) {
            setActiveSlide((prev) => prev - 1);
        }
    };

    return (
        <div className="gap-2 md:flex">
            {/* Mobile Arrows */}
            <div className="flex md:flex-col md:mb-0 mb-4 justify-center items-center gap-2 block md:hidden">
                <div>
                    <img
                        src={LEFTARROW}
                        alt="leftarrow"
                        className={`lg:w-[33.333px] md:w-[29.167px] w-[21.667px] lg:h-[33.333px] md:h-[29.167px] h-[21.667px] cursor-pointer ${activeSlide === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                        onClick={handlePrev}
                    />
                </div>
                <div>
                    <img
                        src={RIGHTARROW}
                        alt="rightarrow"
                        className={`lg:w-[33.333px] md:w-[29.167px] w-[21.667px] lg:h-[33.333px] md:h-[29.167px] h-[21.667px] cursor-pointer ${activeSlide === slideCount - 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                        onClick={handleNext}
                    />
                </div>
            </div>

            {/* Carousel Content */}
            <div className="relative overflow-hidden w-full lg:h-[400px] md:h-[350px] h-[300px] rounded-[16px]">
                {slides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`absolute w-full lg:h-[400px] md:h-[350px] h-[300px] flex items-center justify-center text-xl font-bold transition-all duration-250 ease-in-out 
                            ${index === activeSlide ? "opacity-100 top-0" : "opacity-0 top-10"}`}
                    >
                        <img src={slide.img} alt="slide" className="w-full h-full object-cover rounded-[16px]" />
                        {/* Content Overlay */}
                        {/* <div className="absolute bottom-4 left-[50%] transform -translate-x-1/2 bg-white bg-opacity-50 w-full md:max-w-[60%] max-w-[95%] p-3 rounded-md">
                            <h2 className="lg:text-[24px] md:text-[20px] text-[16px] bold">{slide.title}</h2>
                            <p className="lg:text-[14px] text-[12px] leading-[20px]">{slide.description}</p>
                        </div> */}
                    </div>
                ))}
            </div>

            {/* Desktop Arrows */}
            <div className="flex justify-center items-center">
                <div className="md:block hidden">
                    <div className="flex flex-col justify-center items-center gap-2">
                        <div>
                            <img
                                src={UPARROW}
                                alt="uparrow"
                                className={`lg:w-[33.333px] md:w-[29.167px] w-[21.667px] lg:h-[33.333px] md:h-[29.167px] h-[21.667px] cursor-pointer ${activeSlide === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                                onClick={handlePrev}
                            />
                        </div>
                        <div>
                            <img
                                src={DOWNARROW}
                                alt="downarrow"
                                className={`lg:w-[33.333px] md:w-[29.167px] w-[21.667px] lg:h-[33.333px] md:h-[29.167px] h-[21.667px] cursor-pointer ${activeSlide === slideCount - 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                onClick={handleNext}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerticalCarousel;

